export async function getAuthenticatedHomeRoute(_uid: string): Promise<"/video"> {
    return "/video";
}
